import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import { StyledMixin } from "~/declarations/styled";
import typography from "~/theme/typography";

export const NftPageFeedCardWrapper = styled.article`
  border: 1px solid ${({ theme }) => theme.palette.background.senary};
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(5)};
  position: relative;
`;

export const NftPageFeedCardFooter = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(6)};
  justify-content: space-between;
  margin-top: auto;

  & > * {
    flex: 1 1 50%;
  }
`;

export const NftPageFeedCardFooterDivider = styled(Divider)`
  background: ${({ theme }) => theme.palette.background.senary};
  margin: ${({ theme }) => theme.spacing(3, 0)};
`;

export const nftPageFeedCardTitleMarginMixin: StyledMixin = ({ theme }) => css`
  margin-top: ${theme.spacing(4)};

  ${theme.breakpoints.up("sm")} {
    margin-top: ${theme.spacing(5)};
  }
`;

export const nftPageFeedCardDescriptionMarginMixin: StyledMixin = ({
  theme
}) => css`
  margin-top: ${theme.spacing(2)};
`;

export const NftPageFeedCardImageBase = styled.img`
  border-radius: 24px;
  display: block;
  object-fit: cover;
  width: 100%;
`;

export const NftCardTitle = styled(Typography)`
  ${nftPageFeedCardTitleMarginMixin}

  ${typography.h5};

  display: block;
`;

export const nftCardButtonWidthMixin: StyledMixin = () => css`
  max-width: 144px;
  width: 100%;
`;
